import { render } from "./EditIconButton.vue?vue&type=template&id=f245451c"
import script from "./EditIconButton.vue?vue&type=script&lang=js"
export * from "./EditIconButton.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\FormBuilder\\vue_project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__